/* HomePlunge chiller quiz.

   Scoring, not branching. Every answer adds weight to one model and the higher
   total wins, so a buyer who is tight on space but wants deep cold still gets a
   real answer instead of whichever question happened to come last.

   The weights come straight from the compare page's own "which one is right for
   you" section. Space and temperature are the two answers people actually
   choose on, so they carry the most, and nothing else can outvote them alone. */
(function () {
  var root = document.querySelector('[data-hpq]');
  if (!root || root.dataset.hpqWired) return;
  root.dataset.hpqWired = '1';

  var steps = Array.prototype.slice.call(root.querySelectorAll('.hpq__step'));
  var segs = Array.prototype.slice.call(root.querySelectorAll('.hpq__seg'));
  var counter = root.querySelector('[data-hpq-count]');
  var backBtn = root.querySelector('[data-hpq-back]');
  var resultStep = root.querySelector('[data-hpq-result]');
  var questions = steps.filter(function (s) { return s !== resultStep; });
  if (!questions.length || !resultStep) return;

  var picks = [];   // one entry per answered question: {h3: n, bella: n}
  var at = 0;

  function paint() {
    steps.forEach(function (s, i) { s.classList.toggle('is-active', i === at); });
    segs.forEach(function (s, i) { s.classList.toggle('is-done', i < at); });
    if (counter) {
      counter.textContent = at < questions.length
        ? 'Question ' + (at + 1) + ' of ' + questions.length
        : 'Your result';
    }
    if (backBtn) backBtn.hidden = at === 0;
    // Keep the question in view on a phone without yanking the whole page.
    if (at > 0) {
      var top = root.getBoundingClientRect().top + window.scrollY - 24;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function decide() {
    var h3 = 0, bella = 0;
    picks.forEach(function (p) { h3 += p.h3; bella += p.bella; });
    var winner = bella > h3 ? 'bella' : 'h3';
    var margin = Math.abs(h3 - bella);

    resultStep.querySelectorAll('[data-hpq-card]').forEach(function (card) {
      card.hidden = card.dataset.hpqCard !== winner;
    });
    // A close call is a real outcome, not a failure. Say so rather than
    // pretending the other model was never in contention.
    resultStep.querySelectorAll('[data-hpq-close]').forEach(function (el) {
      el.hidden = !(margin <= 2 && el.dataset.hpqClose === winner);
    });

    try {
      document.dispatchEvent(new CustomEvent('hpq:result', {
        bubbles: true, detail: { winner: winner, h3: h3, bella: bella }
      }));
    } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    var opt = e.target.closest ? e.target.closest('.hpq__opt') : null;
    if (opt && root.contains(opt)) {
      e.preventDefault();
      var step = opt.closest('.hpq__step');
      step.querySelectorAll('.hpq__opt').forEach(function (o) { o.classList.remove('is-picked'); });
      opt.classList.add('is-picked');
      picks[at] = {
        h3: parseInt(opt.dataset.h3 || '0', 10) || 0,
        bella: parseInt(opt.dataset.bella || '0', 10) || 0
      };
      at = Math.min(at + 1, steps.length - 1);
      if (at === steps.length - 1) decide();
      paint();
      return;
    }
    if (e.target.closest && e.target.closest('[data-hpq-back]')) {
      e.preventDefault();
      at = Math.max(0, at - 1);
      paint();
      return;
    }
    if (e.target.closest && e.target.closest('[data-hpq-restart]')) {
      e.preventDefault();
      picks = []; at = 0;
      root.querySelectorAll('.hpq__opt').forEach(function (o) { o.classList.remove('is-picked'); });
      paint();
    }
  });

  // Answers are buttons, so Enter and Space already work. Nothing else to wire.
  paint();
})();
